(function(){
     'use strict';

     angular
        .module('appback')
        .factory('CuentaService', CuentaService);

    CuentaService.$inject = ['$http'];

    function CuentaService($http){


        var service= {
            saveCampos:saveCampos,
            getCuentaCarrier:getCuentaCarrier
        };

        return service;

        function getCuentaCarrier(type,id)
        {

             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            return $http.get('/backend/cuenta/getcuentacarrier', { params : { id:id, type:type } }, config)
            
        }
        function saveCampos(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                type: "cuenta",
                id:vm.id,
                lang_id:1,
                campos:vm.camposActual
            });
            $http.post('/backend/cuenta/save', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
    }
})();